import { useSelector } from 'react-redux';
import { AWAITING_PAYMENT, AWAITING_SHIPMENT, ON_HOLD } from '../../../services/api/order-status-from-view-service';
import Global from '../../../store/global-selectors';
import { getActualSalesOrderIds } from '../../../store/orders/orders.helpers';

const advancedSearchOtherActionsAllowedStatus = [ON_HOLD, AWAITING_SHIPMENT, AWAITING_PAYMENT];

export const useAdvancedSearchStatusDisabled = () => {
  const selectedOrdersIds = useSelector(Global.selectSelectedOrdersIds);
  const actualSelectedOrdersIds = useSelector((state) => getActualSalesOrderIds(state, selectedOrdersIds));
  const fulfillmentPlans =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlansBySalesOrderIds(state, {
        salesOrderIds: actualSelectedOrdersIds,
      }),
    ) || [];

  const fulfillmentPlanStatuses = new Set(fulfillmentPlans.map((plan) => plan.orderGridStatus));

  const hasDisablingAdvancedSearchStatus = [...fulfillmentPlanStatuses].some(
    (stat) => !advancedSearchOtherActionsAllowedStatus.includes(stat),
  );

  return hasDisablingAdvancedSearchStatus;
};
